import React from "react";

const JotformIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2785_913)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.7972 37.3785C12.5398 38.0984 12.015 39.3318 10.9605 39.3318H4.36142C3.05942 39.3318 2 38.3048 2 37.0425V30.6452C2 29.623 3.2723 29.1143 4.01488 29.8342L11.7972 37.3785Z",
  fill: "#0A1551"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.1122 37.8763C20.1589 35.9357 20.1589 32.7893 22.1122 30.8487L29.1619 23.8449C31.1153 21.9043 34.2823 21.9043 36.2357 23.8449C38.189 25.7856 38.189 28.932 36.2357 30.8726L29.186 37.8763C27.2326 39.8169 24.0657 39.8169 22.1122 37.8763Z",
  fill: "#FFB629"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.48932 20.278C1.53595 18.3373 1.53595 15.191 3.48932 13.2504L15.3532 1.45548C17.3065 -0.485158 20.4736 -0.485161 22.4269 1.45548C24.3803 3.39612 24.3803 6.54251 22.4269 8.48317L10.5631 20.278C8.6097 22.2186 5.44267 22.2186 3.48932 20.278Z",
  fill: "#0099FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.1874 28.6844C11.2341 26.7438 11.2341 23.5974 13.1874 21.6567L29.2177 5.73099C31.171 3.79035 34.338 3.79035 36.2914 5.73099C38.2448 7.67165 38.2448 10.818 36.2914 12.7586L20.2612 28.6844C18.3078 30.625 15.1408 30.625 13.1874 28.6844Z",
  fill: "#FF6100"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2785_913"
}, /*#__PURE__*/React.createElement("rect", {
  width: 35.9322,
  height: 40,
  fill: "white",
  transform: "translate(2)"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(JotformIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;